import '../styles/page-kyrklig.scss'
import Swiper from '../js/vendor/swiper/swiper.min';

let directorsSwiper = new Swiper('.director-container', {
    updateOnWindowResize: true,
    keyboard: false,
    allowTouchMove: false,
    mousewheel: false,
    slidesPerView: 3.3,
    spaceBetween:40,
    simulateTouch:false,
    grabCursor: true,
    initialSlide:0,
    //watchSlidesVisibility: true,
    loop:true,
    loopedSlides:15,
    navigation: {
        nextEl: '.swiper-button-next-director',
        prevEl: '.swiper-button-prev-director',
    },
    breakpoints: {
        1300: {
            slidesPerView: 2.3,
            spaceBetween:20,
            allowTouchMove: false,
            simulateTouch:false,
            grabCursor: true,
            initialSlide:0,
            loop:true,
            loopedSlides:15,
            navigation: {
                nextEl: '.swiper-button-next-director',
                prevEl: '.swiper-button-prev-director',
            }
        },
        991: {
            slidesPerView: 1.3,
            spaceBetween:20,
            allowTouchMove: false,
            simulateTouch:false,
            grabCursor: true,
            initialSlide:0,
            loop:true,
            loopedSlides:15,
            navigation: {
                nextEl: '.swiper-button-next-director',
                prevEl: '.swiper-button-prev-director',
            }
        },
        768: {
            slidesPerView: 1.3,
            spaceBetween:20,
            allowTouchMove: false,
            simulateTouch:false,
            grabCursor: true,
            initialSlide:0,
            loop:true,
            loopedSlides:15,
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next-director',
                prevEl: '.swiper-button-prev-director',
            }
        },
        576: {
            slidesPerView: 1.3,
            spaceBetween:20,
            allowTouchMove: false,
            simulateTouch:false,
            grabCursor: true,
            initialSlide:0,
            centeredSlides: true,
            loop:true,
            loopedSlides:15,
            navigation: {
                nextEl: '.swiper-button-next-director',
                prevEl: '.swiper-button-prev-director',
            }
        }
    }
});

//Kyrklig, borgerlid and direktkremation page services compare slider
let tableCompareSwiper = new Swiper('.table-compare--slider', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    grabCursor: true,
    autoplay: false,
    keyboard: false,
    allowTouchMove: false,
    mousewheel: false,
    breakpoints: {
        1200: {
            slidesPerView: 2.5,
            allowTouchMove: true,
            initialSlide: 0,
            navigation: {
                nextEl: '.table-button-next',
                prevEl: '.table-button-prev',
            },
        },
        991: {
            slidesPerView: 2,
            allowTouchMove: true,
            initialSlide: 0,
            navigation: {
                nextEl: '.table-button-next',
                prevEl: '.table-button-prev',
            },
        },
        767: {
            slidesPerView: 2,
            allowTouchMove: true,
            initialSlide: 0,
            navigation: {
                nextEl: '.table-button-next',
                prevEl: '.table-button-prev',
            },
        },
        576: {
            slidesPerView: 1.3,
            centeredSlides: true,
            allowTouchMove: true,
            initialSlide: 0,
            simulateTouch:true,
            grabCursor: true,
            spaceBetween: 15,
            navigation: {
                nextEl: '.table-button-next',
                prevEl: '.table-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        }
    }
});

let buttonSwiper = new Swiper('.filters-container', {
    slidesPerView: 4,
    slidesPerColumn: 4,
    spaceBetween:35,
    slidesPerColumnFill:'row',
    autoplay: false,
    keyboard: false,
    allowTouchMove: false,
    mousewheel: false,
    breakpoints: {
        1200: {
            slidesPerView: 3.5,
            slidesPerColumn: 1,
            spaceBetween:20,
            slidesPerColumnFill:'column',
            initialSlide: 0,
            allowTouchMove: true,
            simulateTouch:true,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next-button',
                prevEl: '.swiper-button-prev-button',
            },
        },
        991: {
            slidesPerView: 2.5,
            slidesPerColumn: 1,
            spaceBetween:20,
            slidesPerColumnFill:'column',
            initialSlide: 0,
            allowTouchMove: true,
            simulateTouch:true,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next-button',
                prevEl: '.swiper-button-prev-button',
            },
        },
        768: {
            slidesPerView: 1.5,
            slidesPerColumn: 1,
            spaceBetween:20,
            slidesPerColumnFill:'column',
            initialSlide: 0,
            allowTouchMove: true,
            simulateTouch:true,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next-button',
                prevEl: '.swiper-button-prev-button',
            },
        },
        576: {
            slidesPerView: 1.3,
            slidesPerColumn: 1,
            spaceBetween:20,
            slidesPerColumnFill:'column',
            initialSlide: 0,
            centeredSlides: true,
            allowTouchMove: true,
            simulateTouch:true,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next-button',
                prevEl: '.swiper-button-prev-button',
            },
        }
    }
});

let productBrowser = {
    init: function (){
        this.initRootCats();
    },
    initRootCats: function (){
        const $this = this;
        const cats = document.getElementsByClassName('filter-category');

        for (let i = 0; i < cats.length; i++) {
            cats[i].addEventListener('click',function (){
                $this.clearActiveCategoryClasses();
                $this.addClass(this, $this.activeClass);

                $this.makeRequest({
                    category: this.getAttribute('data-id'),
                    order: '',
                    page: 1
                }, 'init');

            }, false);
        }
    },
    initSubCats: function (){
        const $this = this;
        const cats = document.getElementsByClassName('filter-subcategory');
        const orderSelector = document.getElementById($this.orderSelectId);

        for (let i = 0; i < cats.length; i++) {
            cats[i].addEventListener('click',function (){
                $this.clearActiveSubCategoryClasses();
                $this.addClass(this, $this.activeClass);

                $this.makeRequest({
                    category: this.getAttribute('data-id'),
                    order: orderSelector.value,
                    page: 1
                }, 'order');

            }, false);
        }
    },
    clearProductWrapper: function (){
        let element = document.getElementById("products-wrapper");
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    },
    getActiveCategoryId: function (){
        const subCatButton = document.querySelectorAll('.filter-subcategory.active');
        if (subCatButton.length) {
            return subCatButton[0].getAttribute('data-id');
        }

        const catButton = document.querySelectorAll('.filter-category.active');
        return catButton[0].getAttribute('data-id');
    },
    displayMoreButton: function (initPage){
        const $this = this;
        const parent = document.getElementById(this.productWrapperId);
        const wrapper = document.createElement("div");
        const categoryId = $this.getActiveCategoryId();
        const orderSelector = document.getElementById($this.orderSelectId);

        wrapper.className = 'products-more';
        wrapper.id = this.productMoreWrapperId;
        wrapper.innerHTML = `<button id="${$this.productMoreButtonId}" data-category="${categoryId}" data-page="${initPage}" type="button" class="btn btn-primary btn-white btn--shadow btn-white--border">Se fler</button>`;
        parent.appendChild(wrapper);

        const button = document.getElementById('moreProducts');
        button.addEventListener('click', function (){
            const page = this.getAttribute('data-page');
            const category = this.getAttribute('data-category');
            this.disabled = true;

            $this.makeRequest({
                category: category,
                order: orderSelector.value,
                page: page
            }, 'append');
        });
    },
    makeRequest: function (params, type){
        const $this = this;
        let httpRequest;
        if (window.XMLHttpRequest) {
            httpRequest = new XMLHttpRequest();
        } else if (window.ActiveXObject) {
            httpRequest = new ActiveXObject("Microsoft.XMLHTTP");
        }

        httpRequest.onreadystatechange = function (){
            if (httpRequest.readyState === XMLHttpRequest.DONE) {

                const moreButton = document.getElementById($this.productMoreButtonId);

                if (httpRequest.status === 200) {
                    const response = JSON.parse(httpRequest.responseText);

                    if (type === 'init') {
                        $this.clearProductWrapper();
                        $this.displayCategoryHeader(response.category);
                        $this.displaySortWrapper(response.productsCurrentCount, response.productsTotalCount, response.subcats);
                        $this.displayProductList();
                        $this.displayProducts(response.products);
                        if (response.productsCurrentCount < response.productsTotalCount){
                            $this.displayMoreButton(2);
                        }
                        $this.scrollToProductList();
                    }
                    if (type === 'order') {
                        document.getElementById($this.productListId).innerHTML = '';
                        const more = document.getElementById($this.productMoreWrapperId);
                        if (more) {
                            more.remove()
                        }
                        $this.displayProducts(response.products);

                        if (response.productsCurrentCount < response.productsTotalCount){
                            $this.displayMoreButton(2);
                        }
                    }
                    if (type === 'append') {
                        $this.displayProducts(response.products);
                        if (response.productsCurrentCount < response.productsTotalCount){
                            const button = document.getElementById($this.productMoreButtonId);
                            const currentPage = button.getAttribute('data-page');
                            button.setAttribute('data-page', parseInt(currentPage) + 1);

                            moreButton.disabled = false;
                        } else {
                            document.getElementById($this.productMoreWrapperId).remove();
                        }
                    }

                    $this.updateCount(response.productsCurrentCount, response.productsTotalCount);
                    console.log(response);
                } else {
                    console.log('There was a problem with the request.');
                    if (moreButton){
                        moreButton.disabled = false;
                    }
                }
            }
        };
        httpRequest.open('POST', $this.requestUrl);
        httpRequest.setRequestHeader('Content-Type', $this.requestContentType);
        httpRequest.send($this.generateParamsString(params));
    },
    displayProducts: function (items){
        const parent = document.getElementById(this.productListId);
        const $this = this;
        items.map(function (item) {
            parent.appendChild($this.productTemplate(item));
            $this.preloadImage(item.image, item.id);
        }, items);
    },
    preloadImage: function (url, id){
        if (url === null) {
            return false;
        }
        const imgElement = document.getElementById(`img-${id}`);
        const img = new Image();
        img.src = url;
        img.onload = function (){
            imgElement.setAttribute('src', img.src)
        };
    },
    productTemplate: function (item){
        const image = item.image === null ? '/wp-content/themes/fenix4/images/bild-saknas.jpg' : '/wp-content/themes/fenix4/dist/images/1x1_placeholder.png';
        const name = item.name;
        let price = item.price;
        const priceRange = item.priceRange;

        if (price === '' || price === '0') {
            price = priceRange;
        }
        const wrapper = document.createElement("div");
        wrapper.className = 'product-item';
        wrapper.innerHTML = `
            <a href="/ordna-begravning/produkt/${item.slug}/" class="product-item__link">
                <div class="product-item__image">
                    <img id="img-${item.id}" src="${image}" alt="${name}">
                </div> 
                <div class="product-item__content">
                    <div class="product-item__title">${name}</div>
                    <div class="product-item__details">
                        <div class="product-item__more">Se fler…</div>
                        <div class="product-item__price">${price} kr</div>
                    </div>
                </div>
            </a>
        `;
        return wrapper;
    },
    displayProductList: function (){
        const parent = document.getElementById(this.productWrapperId);
        const wrapper = document.createElement("div");
        wrapper.className = 'products-list';
        wrapper.id = this.productListId;
        parent.appendChild(wrapper);
    },
    updateCount: function (current, total){
        const currentElm = document.getElementById('current-products-count');
        currentElm.innerHTML = current;

        const totalElm = document.getElementById('total-products-count');
        totalElm.innerHTML = total;
    },
    displaySortWrapper: function (currentCount, totalCount, subcats){
        const $this = this;
        const parent = document.getElementById(this.productWrapperId);

        const wrapper = document.createElement("div");
        wrapper.className = 'sort-wrapper';
        wrapper.innerHTML = `
            <div class="sort-row">
                <div>Visar <span id="current-products-count">${currentCount}</span> av <span id="total-products-count">${totalCount}</span> resultat</div>
                <div class="sorting-select">
                    <span>Sortera efter</span>
                    <select id="${this.orderSelectId}">
                        <option value="featured">Utvalda</option>
                        <option value="price-asc">Pris: Stigande</option>
                        <option value="price-desc">Pris: Fallande</option>
                        <option value="name-asc">A-Z</option>
                        <option value="name-desc">Z-A</option>
                    </select>
                </div>
            </div>
        `;
        parent.appendChild(wrapper);

        if (subcats.length > 0) {
            const d = subcats.reduce(function (acc, cur){
                return `${acc}<button type="button" data-id="${cur.id}" class="filter-subcategory btn btn-primary btn-grey btn-grey--border">${cur.name}</button>`
            }, '');
            const parentCatId = subcats[0].parent;

            const sub = document.createElement("div");
            sub.className = 'sort-buttons';
            sub.innerHTML = `<button type="button" data-id="${parentCatId}" class="filter-subcategory btn btn-primary btn-grey btn-grey--border active">Se alla</button>${d}`;
            parent.appendChild(sub);

            this.initSubCats();
        }

        document.getElementById(this.orderSelectId).addEventListener('change', function (e){
            $this.makeRequest({
                category: $this.getActiveCategoryId(),
                order: e.target.value,
                page: 1
            }, 'order');
        });
    },
    displayCategoryHeader: function (category){
        const parent = document.getElementById(this.productWrapperId);

        const wrapper = document.createElement("div");
        wrapper.className = 'products-wrapper__title';

        const h2 = document.createElement("h2");
        h2.innerHTML = category.name;

        const descWrapper = document.createElement("div");
        descWrapper.className = 'products-wrapper__text';
        descWrapper.innerHTML = category.desc

        wrapper.appendChild(h2);
        h2.after(descWrapper);

        parent.appendChild(wrapper);
    },
    clearActiveCategoryClasses: function (){
        const cats = document.getElementsByClassName('filter-category');

        for (let i = 0; i < cats.length; i++) {
            this.removeClass(cats[i])
        }
    },
    clearActiveSubCategoryClasses: function (){
        const cats = document.getElementsByClassName('filter-subcategory');

        for (let i = 0; i < cats.length; i++) {
            this.removeClass(cats[i])
        }
    },
    addClass: function (element, cl){
        const arr = element.className.split(" ");
        if (arr.indexOf(cl) === -1) {
            element.className += " " + cl;
        }
    },
    removeClass: function (element){
        var reg = new RegExp(` ${this.activeClass}`,"g");
        element.className = element.className.replace(reg, "");
    },
    scrollToProductList: function (){
        const element = document.getElementById(this.productWrapperId);

        document.documentElement.scrollTo({
            top: element.offsetTop - 160,
            left: 0,
            behavior: 'smooth'
        });
    },
    generateParamsString: function (obj){
        return Object.keys(obj).map(function(key) {
            return key + '=' + obj[key];
        }).join('&');
    },
    activeClass: 'active',
    productListId: 'productsList',
    productWrapperId: 'products-wrapper',
    productMoreWrapperId: 'products-more',
    productMoreButtonId: 'moreProducts',
    requestUrl: '/wp-content/themes/fenix4/pages/ajax-customized-funeral-product-list.php',
    requestContentType: 'application/x-www-form-urlencoded',
    orderSelectId: 'product-select'
}
productBrowser.init();

if (window.innerWidth < 576) {
    let accItem = document.getElementsByClassName('about-why__column');
    let mobMenuBtn = document.getElementsByClassName("about-why__header");
    let i;
    for (i = 0; i < mobMenuBtn.length; i++) {
        mobMenuBtn[i].addEventListener('click', toggleItem, false);
    }

    function toggleItem() {
        let itemClass = this.parentNode.className;
        for (i = 0; i < accItem.length; i++) {
            accItem[i].className = 'about-why__column collapsed';
        }
        if (itemClass == 'about-why__column collapsed') {
            this.parentNode.className = 'about-why__column active';
        }
    }
}

